
const WattsPage = (props) => {

    const setValue = () => {
        let userInput = document.getElementById('watt-input')
        props.userInputValue(userInput.value)
        console.log(userInput.value)
    }
    
    return(
        <div className="h-100">
            <div className="row space-between">
                <div className="right-third">
                    <h1 className="title-text mb-1">Choose the amount of solar watts that we’ll send into Mississippi, with your help.</h1>
                    <div className="row flex-start">
                        <div className="input-rect mr-1">
                            <input 
                                type="number"
                                id='watt-input'
                                className="number-input"
                                ></input>
                            <p id="mt">w</p>
                        </div>
                        <div>
                            <button className="pointer" onClick={()=> {
                                props.setPage('almostThere')
                                setValue()
                                }}>Submit</button>
                            <p className="f-12 f-yellow pointer" onClick={()=> props.setPage('home')}>Or choose another way</p>
                        </div>
                    </div>
                </div>
                <div className="sign-conntainer">
                    <div className="sign-top"></div>
                    <div className="sign">
                        <p className="f-16 align-center">Help us reach our 10 million watt goal of expanding access to clean energy for up to 2000 homes in the Panola, MS community.</p>
                    </div>
                </div>
            </div>
            <div className="align-end mt-5">

                <p className="f-14 f-gray">Change your mind? Choose a different way to get involved.</p>
                <div className="row space-between">
                    <div className="f-12 pointer f-c" onClick={() => props.setPage('tons')}>
                        METRIC TONS
                    </div>
                    <div className="footer-line"></div>
                    <div className="f-12 pointer f-c" onClick={() => props.setPage('dollars')}>
                        DOLLARS INVESTED
                    </div>
                    <div className="footer-line"></div>
                    <div className="f-yellow f-12 f-c">
                        NEW SOLAR WATTS
                    </div>
                </div>
            </div>
        </div>
    )
}

export default WattsPage;